import SalesOrdersPageComponent from "./components/SalesOrdersPageComponent";
import {
  uploadImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils"
import axios from "axios";

const getOrders = async () => {
  const { data } = await axios.get("/api/orders/admin");
  return data
}

const getDeliveryBooks = async () => {
  const { data } = await axios.get("/api/deliveryBooks");
  return data
}

const updateDeliveryBook = async (company, label, dateNow, contactName, contactInfo) => {
  const followUpKeyMap = {
    "Email": "email",
    "Call 1": "call1",
    "Call 2": "call2",
    "Visit": "visit"
  };

  const key = followUpKeyMap[label];

  const response = await axios.put("/api/deliveryBooks/admin/updateContactStatus", {
    companyName: company,
    [`followUp.${key}.completed`]: true,
    [`followUp.${key}.date`]: dateNow,
    [`followUp.${key}.contactName`]: contactName,
    [`followUp.${key}.contactInfo`]: contactInfo
  });

  return response;
};

const updateUser = async (user, label, dateNow) => {
  const followUpKeyMap = {
    "Email-1": "email1",
    "Call-1": "call1",
    "Email-2": "email2",
    "Call-2": "call2",
  };

  const key = followUpKeyMap[label];
  const requestBody = {
    user: user,

    [`followUp.${key}.completed`]: true,
    [`followUp.${key}.date`]: dateNow,
  };

  // Only for Call-1
  if (label === "Call-1") {
    requestBody.contacted = true;
    requestBody.contactedDate = dateNow;
  }

  const response = await axios.put(
    "/api/users/admin/updateContactStatus",
    requestBody
  );

  return response;
};

const getAllUsers = async (company) => {
  const { data } = await axios.get("/api/users/");
  return data
};

const fetchCharts = async () => {
  const { data } = await axios.get(`/api/charts`);
  return data;
}

const AdminSalesOrdersPage = () => {
  return <SalesOrdersPageComponent
    getOrders={getOrders}
    getDeliveryBooks={getDeliveryBooks}
    getAllUsers={getAllUsers}
    fetchCharts={fetchCharts}
    updateDeliveryBook={updateDeliveryBook}
    uploadImagesApiRequest={uploadImagesApiRequest}
    uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
    updateUser={updateUser} />

};

export default AdminSalesOrdersPage;

